<template>
    <div class="w-full">
        <div class="flex flex-wrap md:flex-row flex-col-reverse items-end">
            <div class="w-full md:w-3/4 md:p-0 mx-auto">
                <div class="w-full flex items-end">
                    <products-search
                        v-model="lastProductSelected"
                        class="mt-4"
                        :default-filters="defaultFilters"
                        @focus="onFocusSomeInput"
                        @blur="onBlurSomeInput"
                        @input="selectProduct"
                    />
                </div>
            </div>
            <div class="w-full md:w-1/4">
                <div
                    class="w-full flex justify-center lg:flex-row flex-col-reverse"
                >
                    <products-barcode-scanner
                        v-model="isEnabledScanner"
                        @input="selectProduct"
                    />
                    <div class="flex justify-center">
                        <slot name="complement"></slot>
                    </div>
                </div>
            </div>
        </div>
        <product-reference-modal
            v-model="openModalReferences"
            :product-name="productTmp.name"
            :references="productTmp.references"
            :reference-selected="referenceSelected"
            show-confirm-button
            @close="isEnabledScanner = true"
            @select="selectReference"
            @confirm="pushReference"
        />
    </div>
</template>

<script>
import ProductsBarcodeScanner from "@/components/products/ProductsBarcodeScanner.vue";
import ProductsSearch from "@/components/products/ProductsSearch.vue";
import ProductReferenceModal from "@/components/utils/ProductReferenceModal.vue";

export default {
    name: "ReferencesSearchScanner",
    components: {
        ProductsSearch,
        ProductsBarcodeScanner,
        ProductReferenceModal
    },
    props: {
        defaultFilters: {
            default: () => ({}),
            type: Object,
            required: false
        },
        enabledScanner: {
            default: () => false,
            type: Boolean,
            required: false
        },
        any: {
            default: () => false,
            type: Boolean,
            required: false
        }
    },
    emits: ["input"],
    data: () => ({
        lastProductSelected: { name: "" },
        isEnabledScanner: false,
        openModalReferences: false,
        referenceSelected: null,
        productTmp: {
            id: 68,
            sku: "",
            slug: "",
            name: "",
            references: []
        }
    }),
    computed: {},
    watch: {
        enabledScanner(value) {
            this.isEnabledScanner = value && true;
        }
    },
    mounted() {
        this.isEnabledScanner = true;
        this.addHandlerKey();
    },
    beforeDestroy() {
        this.isEnabledScanner = false;
        this.removeHandlerKey();
    },
    methods: {
        async selectProduct(product) {
            this.productTmp = { ...product };
            if (product.references.length === 0) {
                await this.$swal.fire({
                    background: this.backgroundColor,
                    icon: "error",
                    title: "Producto invalido",
                    text: "Entra a los detalles del producto y verifica que tenga referencias"
                });
                window
                    .open(`/app/products/detail/${product.id}`, "_blank")
                    .focus();
            } else if (product.references.length === 1 || this.any) {
                this.validatePush(product.references[0], product);
                this.openModalReferences = false;
                this.referenceSelected = -1;
                this.isEnabledScanner = true;
            } else {
                this.isEnabledScanner = false;
                this.productTmp = { ...product };
                this.referenceSelected = -1;
                this.openModalReferences = true;
            }
        },
        validatePush(reference, product) {
            this.$emit("input", {
                ...reference,
                appliedDiscountPerReference: 0,
                productId: product.id,
                product: {
                    id: product.id,
                    sku: product.sku,
                    slug: product.slug,
                    name: product.name
                }
            });
            this.referenceSelected = -1;
        },
        pushReference() {
            if (this.referenceSelected < 0) return;
            const reference =
                this.productTmp.references[this.referenceSelected];
            this.validatePush(reference, this.productTmp);
            this.openModalReferences = false;
            this.referenceSelected = -1;
            this.isEnabledScanner = true;
        },
        selectReference(index) {
            if (index < 0) {
                return;
            }
            this.isEnabledScanner = false;
            this.referenceSelected = index;
        },
        incrementReferenceSelect() {
            this.isEnabledScanner = false;
            if (!this.openModalReferences) return;
            if (this.referenceSelected < 0) {
                this.referenceSelected = 0;
            } else if (
                this.referenceSelected <
                this.productTmp.references.length - 1
            ) {
                this.referenceSelected = this.referenceSelected + 1;
            }
        },
        decrementReferenceSelect() {
            this.isEnabledScanner = false;
            if (!this.openModalReferences) return;
            if (this.referenceSelected < 0) {
                this.referenceSelected = 0;
            } else if (this.referenceSelected > 0) {
                this.referenceSelected = this.referenceSelected - 1;
            }
        },
        onEnter() {
            if (this.openModalReferences) {
                this.pushReference();
            }
        },
        handleKey(event) {
            const actions = {
                Enter: this.onEnter,
                Escape: this.closeReferenceModal,
                ArrowUp: this.decrementReferenceSelect,
                ArrowDown: this.incrementReferenceSelect
            };
            const fun = actions[event.key] || function () {};
            fun();
        },
        closeReferenceModal() {
            this.openModalReferences = false;
            this.isEnabledScanner = true;
        },
        removeHandlerKey() {
            document.removeEventListener("keydown", this.handleKey);
        },
        addHandlerKey() {
            document.addEventListener("keydown", this.handleKey);
        },
        onBlurSomeInput() {
            this.isEnabledScanner = true;
            this.addHandlerKey();
        },
        onFocusSomeInput() {
            this.isEnabledScanner = false;
            this.removeHandlerKey();
        }
    }
};
</script>
